import React, { Fragment } from 'react'
import HomeBanner1 from "../../Assets/Images/HomeBanner.png";
import HomeBanner from "../../Assets/Images/image_1.webp";
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaArrowRightLong } from 'react-icons/fa6';

const Homebanner = () => {
    return (
        <Fragment>

            <div className="home-banner align-item-center d-flex">
                <div className="container">
                    <div className="row h-100 ">
                        <div className="col-lg-6">
                            <h2 className='text-white text-capitalize fw-bold s-40'>
                                Find Over 20 Million  Books
                                <br />
                                in renwritters
                            </h2>

                            <p className='text-light s-12'>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sunt, tempore? Expedita ipsum quisquam dicta minima soluta placeat delectus quo</p>

                            <Button as={Link} to={"/books"} className='btn btn-danger px-4 py-3 s-14'>
                                <span className='me-5'>
                                    Go to Collection
                                </span>

                                <span><FaArrowRightLong />
                                </span>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Homebanner